module.exports = __webpack_public_path__ + "img/queen.db4f1a16.png";